export default (pageContents:string):string => `
Here are the contents of the current page that the user is working on (in JSON format for your convenience).

'''
${pageContents}
'''
`;